var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Emitter from './Util/Emitter';
import Constants from './Util/Constants';
import WsCommunication from './Tracker/WSCommunication';
import * as Peer from 'simple-peer';
import Util from './Util/Util';
const OFFER_TIMEOUT = 30000;
const TRACKER_RECONNECT_DELAY = 5000;
/**
 * @class
 * @description Communication class that manages communication with a websocket tracker and gets peer candidates.
 * @extends Emitter
 * @exports P2PManager
 */
export default class P2PManager extends Emitter {
    /**
     * @constructs P2PManager
     * @param {string} hashId ID of the content as string, to be hashed.
     * @param {P2PConfig} config Configuration JSON, including the tracker URL, iceServers...
     * @param {string?} peerId Optional, ID of the peer/user, if not set a random one will be generated.
     * @public
     */
    constructor(hashId, config, peerId) {
        super();
        this._peerList = new Map();
        this._sentOffers = new Map();
        this._myOffers = [];
        this._tempAnswers = new Map();
        this._tempCandidates = new Map();
        this.isOfferProcessStarted = false;
        this._config = config;
        this._hashId = Util.hash(hashId);
        this._peerId = peerId || Util.generateRandomPeerId();
        // this._generateAndSendOfferList();
        this._tracker = new WsCommunication(this._config);
        this._tracker
            .on(Constants.WSCommEvents.Data, this._dataReceived.bind(this))
            .on(Constants.WSCommEvents.Connected, () => {
            this.start();
        })
            .on(Constants.WSCommEvents.Closed, (tracker) => {
            setTimeout(() => tracker.data.start(), TRACKER_RECONNECT_DELAY);
        })
            .on(Constants.WSCommEvents.Error, (e) => {
            this.stop();
            console.warn('Socket error: ', e);
        })
            .start();
    }
    /**
     * Starts the communication with the websocket tracker
     * @public
     */
    start() {
        this._sendWsMessage({ action: Constants.AnnounceEvents.Join });
    }
    /**
     * Ends the communication with the websocket tracker
     * @public
     */
    stop() {
        var _a;
        (_a = this._tracker) === null || _a === void 0 ? void 0 : _a.close();
    }
    /**
     * Destroys the tracker reference and stops the communication
     * @public
     */
    destroy() {
        this.stop();
    }
    /**
     * Sends a message to the tracker if available
     * @param {trackerMessage} message JSON object with the data to be sent to the tracker.
     * @private
     */
    _sendWsMessage(message = {}) {
        var _a;
        const obj = {
            info_hash: this._hashId,
            peer_id: this._peerId,
            token: this._config.token || Constants.Token
        };
        (_a = this._tracker) === null || _a === void 0 ? void 0 : _a.send(Object.assign(obj, message));
    }
    /**
     * Generates an array of offers to be used/sent to the tracker so we can get answers to connect to peers
     * @private
     */
    /*private _generateOfferList() {
  
      this._myOffers = [];
  
      for (let i = 0; i < (this._config.announcePeers || Constants.Default.AnnouncePeers); ++i) {
        const offer_id = Util.generateRandomPeerId();
        const peer = this._createPeer(offer_id);
  
        peer.once(Constants.PeerEvents.Signal, (offer: offerObject) => {
  
          this._myOffers.push({
            offer_id: offer_id,
            sdp: offer.sdp,
            type: offer.type
          });
  
          this._sentOffers.set(offer_id, peer);
  
        });
  
        setTimeout(() => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          if (peer.id == offer_id) {
            //  destroying offer after timeout, if peer id still is offer_id
            this._sentOffers.delete(offer_id);
            peer.destroy();
          }
        }, OFFER_TIMEOUT);
      }
    }*/
    /**
     * Generates an array of offers to be used/sent to the tracker so we can get answers to connect to peers
     * @private
     */
    _generateAndSendOfferList() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isOfferProcessStarted)
                return;
            this.isOfferProcessStarted = true;
            while (true) {
                // if( this._myOffers.length>0 )
                //   return;
                this._myOffers = [];
                /*  let newMyOffers: Offer[] = [];
          
                  for( let i=0; i<this._myOffers.length; i++ ){
                    
                    let offer = this._myOffers[i];
                    
                    if( this._sentOffers.delete(this._myOffers[i].offer_id)!=undefined )
                        newMyOffers.push( this._myOffers[i] );
                  }
          
                  this._myOffers = newMyOffers;
          */
                let total = 20; //(this._config.announcePeers || Constants.Default.AnnouncePeers);
                total = total - this._sentOffers.size;
                for (let i = this._myOffers.length; i < total; ++i) {
                    const offer_id = Util.generateRandomPeerId();
                    const peer = this._createPeer(offer_id);
                    peer.once(Constants.PeerEvents.Signal, (offer) => {
                        this._myOffers.push({
                            offer_id: offer_id,
                            sdp: offer.sdp,
                            type: offer.type
                        });
                        //console.log("PA1 -----> once x "+i);
                        //  this._sendWsMessage({ action: Constants.AnnounceEvents.Offers, offers: this._myOffers });
                        this._sentOffers.set(offer_id, peer);
                    });
                    setTimeout(() => {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        if (peer.id == offer_id) {
                            //  destroying offer after timeout, if peer id still is offer_id
                            this._sentOffers.delete(offer_id);
                            peer.destroy();
                        }
                    }, OFFER_TIMEOUT);
                }
                let init = Date.now();
                //console.log("PA1 a");
                while (this._myOffers.length < (this._config.announcePeers || Constants.Default.AnnouncePeers) && (Date.now() - init) < 10000) {
                    yield new Promise(f => setTimeout(f, 50));
                }
                //console.log("PA1 b");
                if (this._myOffers.length > 0)
                    this._sendWsMessage({ action: Constants.AnnounceEvents.Offers, offers: this._myOffers });
                //console.log("PA1 -----> once "+this._myOffers.length);
                yield new Promise(f => setTimeout(f, 30000));
            }
        });
    }
    /**
     * Creates a peer to offer it, or to send it as answer.
     * @param {string} id ID of the peer to be created.
     * @param {boolean} initiator By defult true, if it has to generate the offer. If not generates the answer.
     * @returns {Peer.Instance} Peer object waiting for events/responses
     * @private
     */
    _createPeer(id, initiator = true) {
        const peer = new Peer({
            initiator,
            trickle: false,
            config: this._config.iceServers || Constants.iceServers
            //wrtc: undefined
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        peer.id = id;
        const connect = () => {
            peer.off(Constants.PeerEvents.Connect, connect);
            peer.off(Constants.PeerEvents.Error, error);
        };
        const error = (err) => {
            this.emit(Constants.WSCommEvents.Warning, 'Error with the peer: ' + err);
            //console.log("PA1 Peer error");
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this._peerList.delete(peer.id);
            peer.destroy();
        };
        const close = () => {
            //console.log("PA1 Clossing peer");
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this._peerList.delete(peer.id);
            peer.destroy();
        };
        peer.on(Constants.PeerEvents.Connect, connect);
        peer.on(Constants.PeerEvents.Error, error);
        peer.on(Constants.PeerEvents.Close, close);
        return peer;
    }
    /**
     * Callback for data events from the tracker
     * It manages all the events used: Offer, Candidates, Answer, Join
     * @param {callbackData} e event callback data
     * @private
     */
    _dataReceived(e) {
        const data = e.data;
        switch (data.action) {
            case Constants.AnnounceEvents.Offer:
                this._handleOffer(data);
                break;
            case Constants.AnnounceEvents.Candidates:
                this._handleCandidates(data);
                break;
            case Constants.AnnounceEvents.Answer:
                this._handleAnswer(data);
                break;
            case Constants.AnnounceEvents.Join:
                this._handleJoin(data);
                break;
        }
    }
    /**
     * Handles tracker join event
     * @param {joinResponse} e event callback data
     * @private
     */
    /*private _handleJoin(e: joinResponse) {
      if ('ok' === e.status) {
        setTimeout(() => {
          this._sendWsMessage({ action: Constants.AnnounceEvents.Offers, offers: this._myOffers });
        }, Constants.trackerCommunicationWait+6000);
        setInterval(
          () => {
            this._generateOfferList();
            setTimeout(() => {
              this._sendWsMessage({ action: Constants.AnnounceEvents.Offers, offers: this._myOffers });
            }, Constants.trackerCommunicationWait + 5000);
          },
          e.interval ? e.interval * 1000 : Constants.trackerInterval
        );
      } else {
        // e.status === 'error'
        setTimeout(this.start, Constants.trackerRetryJoinTime);
      }
    }*/
    _handleJoin(e) {
        if ('ok' === e.status) {
            this._generateAndSendOfferList();
        }
        else {
            setTimeout(this.start, Constants.trackerRetryJoinTime);
        }
    }
    /**
     * Handles tracker answer event
     * @param {answerData} e event callback data
     * @private
     */
    _handleAnswer(e) {
        var _a;
        if (e.answer.sdp.indexOf('a=candidate') < 0) {
            // mobile case
            this._tempAnswers.set(e.peer_id, e.answer);
            (_a = this._tempCandidates.get(e.peer_id)) === null || _a === void 0 ? void 0 : _a.forEach((candidate) => {
                e.answer.sdp += 'a=' + candidate + '\r\n';
            });
        }
        this._manageAnswer(e.answer, e.peer_id);
        this._tempCandidates.delete(e.peer_id);
    }
    /**
     * Handles connection after answer or candidates event
     * @param {answerObject} answer answer callback data/object
     */
    _manageAnswer(answer, peer_id) {
        const peer = this._sentOffers.get(answer.offer_id);
        if (peer) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            peer.id = peer_id;
            this._sentOffers.delete(answer.offer_id);
            this._peerList.set(peer_id, peer);
            peer.signal(answer);
            this.emit(Constants.WebRtcEvents.Peer, peer);
        }
    }
    /**
     * Handles tracker candidates event
     * @param {candidatesData} e event callback data
     * @private
     */
    _handleCandidates(e) {
        var _a;
        const tempAnswer = this._tempAnswers.get(e.peer_id);
        // if answer to be filled?
        (_a = e.candidates) === null || _a === void 0 ? void 0 : _a.forEach((candidate) => {
            var _a;
            if (tempAnswer) {
                tempAnswer.sdp += 'a=' + candidate.candidate + '\r\n';
                this._manageAnswer(tempAnswer, e.peer_id);
            }
            else {
                if (!this._tempCandidates.has(e.peer_id)) {
                    this._tempCandidates.set(e.peer_id, []);
                }
                (_a = this._tempCandidates.get(e.peer_id)) === null || _a === void 0 ? void 0 : _a.push(candidate.candidate);
            }
        });
        if (tempAnswer) {
            this._manageAnswer(tempAnswer, e.peer_id);
            this._tempAnswers.delete(e.peer_id);
        }
    }
    /**
     * Handles tracker offer event
     * @param {offerData} e event callback data
     * @private
     */
    _handleOffer(e) {
        const peerId = e.peer_id;
        const offer = e.offer;
        const offerId = offer.offer_id;
        if (this._peerList.has(peerId)) {
            // peerId already connected
            return;
        }
        const peer = this._createPeer(peerId, false);
        peer.once(Constants.PeerEvents.Signal, (e) => {
            var _a;
            const answer = {
                offer_id: offerId,
                sdp: e.sdp,
                type: e.type
            };
            if (e.sdp.indexOf('a=candidate') > 0) {
                // web
                (_a = this._tracker) === null || _a === void 0 ? void 0 : _a.send({
                    action: Constants.AnnounceEvents.Answer,
                    info_hash: this._hashId,
                    peer_id: this._peerId,
                    to_peer_id: peerId,
                    answer
                });
            }
            else {
                // mobile
                this._tempAnswers.set(peerId, answer);
            }
        });
        this.emit(Constants.WebRtcEvents.Peer, peer);
        peer.signal(offer);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this._peerList.set(peer.id, peer);
    }
}
P2PManager.Util = Util;
P2PManager.Constants = Constants;
